import { Observable } from 'rxjs/Observable';
import { Injectable, Inject } from '@angular/core';

import 'rxjs/add/operator/map';

import { EnvVariables } from "../../app/environment-variables/environment-variables.token";
import { HttpHeaders, HttpClient } from '../../../node_modules/@angular/common/http';

/*
  Generated class for the ResourceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ResourceProvider {

  constructor(
    public http: HttpClient,
    @Inject(EnvVariables) public envVariables
  ) { }

  setHeaders() {
    const token = JSON.parse(window.localStorage.getItem('auth')).token;
    let headers = new HttpHeaders;
    headers = headers.append('Authorization', `Bearer ${token}`)
    return headers;
  }

  getResource(): Observable<any> {
    let headers = this.setHeaders();
    return this.http.get(`${this.envVariables.apiEndpoint}/resources`, { headers });
  }

  updateDockStatus(id, status): Observable<any> {
    let headers = this.setHeaders();
    return this.http.put(`${this.envVariables.apiEndpoint}/dock/status/${id}`, { status }, { headers });
  }

  updateDock(id, data): Observable<any> {
    let headers = this.setHeaders();
    return this.http.put(`${this.envVariables.apiEndpoint}/dock/${id}`, data, { headers });
  }

  clearAllDocks(): Observable<any> {
    let headers = this.setHeaders();
    return this.http.post(`${this.envVariables.apiEndpoint}/dock/clear`, {}, { headers });
  }
}



// WEBPACK FOOTER //
// ./src/providers/resource/resource.ts